import { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Title from "../../components/Title";

import DrawerAppBar from "../../components/DrawerAppBar";
import SubTitle from "../../components/SubTitle";
import ProgressBar from "../../components/ProgressBar";
import { getPendingGradeCounts, getStudentsWithoutGoalsCount } from "../../services/CommServiceService";

import { doService } from "../../services/ServiceHelper";

import { isCommunityServiceEnabled } from "../../services/SchoolService";
import MetricCard from "../../components/MetricCard";
import { randomDarkBlueHex } from "../../services/ScreenService";
import CommServiceSingleDialog from "../../components/admin/CommServiceSingleDialog";
import { COMM_SERVICE_YEAR } from "../../constants/commService";

const VolunteerWelcome = () => {
  const [_jwt] = useJwtStorage();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_showProgress, setShowProgress] = useState(false);
  const [_grades, setGrades] = useState([]);
  const [_commServiceDialogOpen, setCommServiceDialogOpen] = useState(false);
  const [_studentsWithoutGoalsCount, setStudentsWithoutGoalsCount] = useState(0);

  useEffect(() => {
    initSchoolGrades();
    initStudentsWithoutGoalsCount();
  }, []);

  const initStudentsWithoutGoalsCount = () => {
    setShowProgress(true);
    doService(getStudentsWithoutGoalsCount(_school, _jwt), (results) => {
      setStudentsWithoutGoalsCount(results.data);
      setShowProgress(false);
    });    
  };


  const initSchoolGrades = () => {
    setShowProgress(true);
    doService(getPendingGradeCounts(_school, _jwt), (results) => {
      setGrades(results.data);
      setShowProgress(false);
    });
  };

  const onClickAdd = () => {
    setCommServiceDialogOpen(true);
  };

  const onSaveServiceOps = () => {
    setCommServiceDialogOpen(false);
    initSchoolGrades();
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Volunteer Dashboard" />
        <ProgressBar showProgress={_showProgress} />

        {isCommunityServiceEnabled(_school) === true && (
          <>
            <br />
            <Button key="manageTypes" onClick={onClickAdd} variant="contained">
              Add Service Op
            </Button>
            <br />
            <br />
            <SubTitle text={`Key Metrics`} />
            <br />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <MetricCard
                  content={_studentsWithoutGoalsCount}
                  title={"Students w/o Goals"}
                  color={"#ba000d"}
                  textColor="white"
                  titleTop={false}
                  navigateUrl={`/comm-service/students-no-goals?year=${COMM_SERVICE_YEAR}`}
                />
              </Grid>
            </Grid>
                        
            <SubTitle text={`Select Grade`} />
            <Grid container spacing={2}>
              {_grades.map((grade) => (
                <Grid item xs={3}>
                  <MetricCard
                    content={grade.grade}
                    title={"Pending: " + grade.gradeCount}
                    color={randomDarkBlueHex()}
                    textColor="white"
                    titleTop={false}
                    navigateUrl={`/volunteer/ops-by-grade?grade=${grade.grade}`}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Container>

      <CommServiceSingleDialog
        school={_school}
        jwt={_jwt}
        dialogOpen={_commServiceDialogOpen}
        setDialogOpen={setCommServiceDialogOpen}
        onSave={onSaveServiceOps}
      />
    </>
  );
};

export default VolunteerWelcome;
